import React, { useState, useEffect } from 'react';
import { Auth } from '@aws-amplify/auth';  // Auth class for v5
import { Hub } from '@aws-amplify/core';   // Hub from core for v5
import { useHistory } from 'react-router-dom';
import './App.css';


function App() {
  const [prompt, setPrompt] = useState('');
  const [response, setResponse] = useState(null);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);  // Add loading state
  const history = useHistory();

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      if (event === 'signIn') {
        setUser(data);
        history.push('/');
      }
      if (event === 'signOut') setUser(null);
    });
    checkUser();
  }, [history]);

  async function checkUser() {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      setUser(currentUser);
      if (window.location.pathname === '/callback') {
        history.push('/');
      }
    } catch (error) {
      setUser(null);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Sending:', { prompt });
    setIsLoading(true);  // Start loading
    try {
      const token = (await Auth.currentSession()).getIdToken().getJwtToken();
      const res = await fetch('https://api.blend.palpateam.net/blend', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify({ prompt })
      });
      if (!res.ok) {
        const errorData = await res.json();
        console.error('Error response:', errorData);
        throw new Error(`HTTP error ${res.status}: ${JSON.stringify(errorData)}`);
      }
      const data = await res.json();
      setResponse(data);
    } catch (error) {
      console.error('Fetch error:', error);
      setResponse({ blended: `Error: ${error.message}`, grok_response: '', openai_response: '' });
    } finally {
      setIsLoading(false);  // Stop loading
    }
  };

  const signIn = () => Auth.federatedSignIn();
  const signOut = () => Auth.signOut();

  if (!user) {
    return (
      <div className="App">
        <h1>Blend AI</h1>
        <button onClick={signIn} className="blend-button">Sign In</button>
      </div>
    );
  }

  return (
    <div className="App">
      <h1>Blend AI</h1>
      <button onClick={signOut} className="signout-button">Sign Out</button>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Enter your prompt"
          className="prompt-input"
          disabled={isLoading}  // Disable input during loading
        />
        <button type="submit" className="blend-button" disabled={isLoading}>
          {isLoading ? 'Blending...' : 'Blend It'}
        </button>
      </form>
      {isLoading && <div className="loading-indicator">Blending your response...</div>}
      {response && !isLoading && (
        <div className="response-container">
          <h2>Blended Response</h2>
          <p className="blended-text">{response.blended}</p>
          <div className="individual-responses">
            <div className="response-card">
              <h3>Grok Says:</h3>
              <p>{response.grok_response}</p>
            </div>
            <div className="response-card">
              <h3>OpenAI Says:</h3>
              <p>{response.openai_response}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;